(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-kieu-bewerbung-steps"] && !Shopify.designMode) return;
  try {
    
  class DrKieuBewerbungSteps extends HTMLElement {
    connectedCallback() {
      this.triggers = [...this.querySelectorAll('[data-step-trigger]')];
      this.panels = [...this.querySelectorAll('[data-step-panel]')];
      this.previousButtons = [...this.querySelectorAll('[data-step-previous]')];
      this.nextButtons = [...this.querySelectorAll('[data-step-next]')];
      this.status = this.querySelector('[data-step-status]');
      this.activeIndex = Math.max(0, this.triggers.findIndex((trigger) => trigger.getAttribute('aria-selected') === 'true'));
      this.abortController = new AbortController();
      this.autoplayTimer = null;
      this.isPaused = false;

      const signal = this.abortController.signal;
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.activate(Number(trigger.dataset.stepIndex), true), { signal });
        trigger.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      });
      this.previousButtons.forEach((button) => button.addEventListener('click', () => this.move(-1), { signal }));
      this.nextButtons.forEach((button) => button.addEventListener('click', () => this.move(1), { signal }));
      this.addEventListener('mouseenter', () => this.pauseAutoplay(), { signal });
      this.addEventListener('mouseleave', () => this.resumeAutoplay(), { signal });
      this.addEventListener('focusin', () => this.pauseAutoplay(), { signal });
      this.addEventListener('focusout', () => this.resumeAutoplay(), { signal });
      document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), { signal });

      this.render(false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.stopAutoplay();
    }

    get loops() {
      return this.dataset.loop === 'true';
    }

    get autoplays() {
      return this.dataset.autoplay === 'true' && this.triggers.length > 1;
    }

    move(direction, announce = true) {
      const target = this.activeIndex + direction;
      if (this.loops) {
        this.activate((target + this.triggers.length) % this.triggers.length, announce);
      } else {
        this.activate(Math.max(0, Math.min(target, this.triggers.length - 1)), announce);
      }
    }

    activate(index, announce = false) {
      if (!Number.isInteger(index) || index < 0 || index >= this.triggers.length || index === this.activeIndex) return;
      this.direction = index < this.activeIndex ? 'previous' : 'next';
      this.activeIndex = index;
      this.render(announce);
      this.restartAutoplay();
    }

    render(announce) {
      this.triggers.forEach((trigger, index) => {
        const isActive = index === this.activeIndex;
        trigger.setAttribute('aria-selected', String(isActive));
        trigger.tabIndex = isActive ? 0 : -1;
        trigger.toggleAttribute('data-complete', index < this.activeIndex);
      });

      this.panels.forEach((panel, index) => {
        const isActive = index === this.activeIndex;
        panel.toggleAttribute('data-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.toggleAttribute('inert', !isActive);
        panel.dataset.direction = this.direction ?? 'next';
      });

      const activeTrigger = this.triggers[this.activeIndex];
      if (announce && this.status && activeTrigger) {
        this.status.textContent = activeTrigger.innerText.trim();
      }

      const atStart = this.activeIndex === 0;
      const atEnd = this.activeIndex === this.triggers.length - 1;
      this.previousButtons.forEach((button) => {
        button.disabled = !this.loops && atStart;
      });
      this.nextButtons.forEach((button) => {
        button.disabled = !this.loops && atEnd;
      });
    }

    handleKeydown(event) {
      const keys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') this.activeIndex = 0;
      if (event.key === 'End') this.activeIndex = this.triggers.length - 1;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') this.activeIndex = (this.activeIndex - 1 + this.triggers.length) % this.triggers.length;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') this.activeIndex = (this.activeIndex + 1) % this.triggers.length;
      this.render(true);
      this.triggers[this.activeIndex]?.focus();
      this.restartAutoplay();
    }

    startAutoplay() {
      if (!this.autoplays || this.isPaused || document.hidden) return;
      const delay = Number(this.dataset.autoplaySpeed) || 7000;
      this.autoplayTimer = window.setInterval(() => {
        if (this.activeIndex === this.triggers.length - 1 && !this.loops) {
          this.stopAutoplay();
          return;
        }
        this.move(1, false);
      }, delay);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    pauseAutoplay() {
      this.isPaused = true;
      this.stopAutoplay();
    }

    resumeAutoplay() {
      this.isPaused = false;
      this.startAutoplay();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    }
  }

  if (!customElements.get('dr-kieu-bewerbung-steps')) {
    customElements.define('dr-kieu-bewerbung-steps', DrKieuBewerbungSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-kieu-checkup-steps"] && !Shopify.designMode) return;
  try {
    
  class DrKieuCheckupSteps extends HTMLElement {
    connectedCallback() {
      this.triggers = [...this.querySelectorAll('[data-step-trigger]')];
      this.panels = [...this.querySelectorAll('[data-step-panel]')];
      this.previousButtons = [...this.querySelectorAll('[data-step-previous]')];
      this.nextButtons = [...this.querySelectorAll('[data-step-next]')];
      this.timeline = this.querySelector('[data-step-timeline]');
      this.status = this.querySelector('[data-step-status]');
      this.activeIndex = Math.max(0, this.triggers.findIndex((trigger) => trigger.getAttribute('aria-selected') === 'true'));
      this.abortController = new AbortController();
      this.autoplayTimer = null;
      this.isPaused = false;

      const signal = this.abortController.signal;
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.activate(Number(trigger.dataset.stepIndex), true), { signal });
        trigger.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      });
      this.previousButtons.forEach((button) => button.addEventListener('click', () => this.move(-1), { signal }));
      this.nextButtons.forEach((button) => button.addEventListener('click', () => this.move(1), { signal }));
      this.addEventListener('mouseenter', () => this.pauseAutoplay(), { signal });
      this.addEventListener('mouseleave', () => this.resumeAutoplay(), { signal });
      this.addEventListener('focusin', () => this.pauseAutoplay(), { signal });
      this.addEventListener('focusout', () => this.resumeAutoplay(), { signal });
      document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), { signal });

      this.render(false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.stopAutoplay();
    }

    get loops() {
      return this.dataset.loop === 'true';
    }

    get autoplays() {
      return this.dataset.autoplay === 'true' && this.triggers.length > 1;
    }

    move(direction, announce = true) {
      const target = this.activeIndex + direction;
      if (this.loops) {
        this.activate((target + this.triggers.length) % this.triggers.length, announce);
      } else {
        this.activate(Math.max(0, Math.min(target, this.triggers.length - 1)), announce);
      }
    }

    activate(index, announce = false) {
      if (!Number.isInteger(index) || index < 0 || index >= this.triggers.length || index === this.activeIndex) return;
      this.direction = index < this.activeIndex ? 'previous' : 'next';
      this.activeIndex = index;
      this.render(announce);
      this.restartAutoplay();
    }

    render(announce) {
      this.triggers.forEach((trigger, index) => {
        const isActive = index === this.activeIndex;
        trigger.setAttribute('aria-selected', String(isActive));
        trigger.tabIndex = isActive ? 0 : -1;
        trigger.toggleAttribute('data-complete', index < this.activeIndex);
      });

      this.panels.forEach((panel, index) => {
        const isActive = index === this.activeIndex;
        panel.toggleAttribute('data-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.toggleAttribute('inert', !isActive);
        panel.dataset.direction = this.direction ?? 'next';
        if (isActive) panel.querySelector('[data-step-cards]')?.scrollTo({ left: 0, behavior: 'instant' });
      });

      const activeTrigger = this.triggers[this.activeIndex];
      if (announce) {
        activeTrigger?.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      }

      if (announce && this.status && activeTrigger) {
        this.status.textContent = activeTrigger.innerText.trim();
      }

      const atStart = this.activeIndex === 0;
      const atEnd = this.activeIndex === this.triggers.length - 1;
      this.previousButtons.forEach((button) => {
        button.disabled = !this.loops && atStart;
      });
      this.nextButtons.forEach((button) => {
        button.disabled = !this.loops && atEnd;
      });
    }

    handleKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') this.activeIndex = 0;
      if (event.key === 'End') this.activeIndex = this.triggers.length - 1;
      if (event.key === 'ArrowLeft') this.activeIndex = (this.activeIndex - 1 + this.triggers.length) % this.triggers.length;
      if (event.key === 'ArrowRight') this.activeIndex = (this.activeIndex + 1) % this.triggers.length;
      this.render(true);
      this.triggers[this.activeIndex]?.focus();
      this.restartAutoplay();
    }

    startAutoplay() {
      if (!this.autoplays || this.isPaused || document.hidden) return;
      const delay = Number(this.dataset.autoplaySpeed) || 7000;
      this.autoplayTimer = window.setInterval(() => {
        if (this.activeIndex === this.triggers.length - 1 && !this.loops) {
          this.stopAutoplay();
          return;
        }
        this.move(1, false);
      }, delay);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    pauseAutoplay() {
      this.isPaused = true;
      this.stopAutoplay();
    }

    resumeAutoplay() {
      this.isPaused = false;
      this.startAutoplay();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  if (!customElements.get('dr-kieu-checkup-steps')) {
    customElements.define('dr-kieu-checkup-steps', DrKieuCheckupSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-kieu-journal-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-dk-article-progress]');
    const body = document.querySelector('.dk-article__content');
    if (!bar || !body) return;
    const update = () => {
      const rect = body.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.5;
      const done = Math.min(Math.max(-rect.top + window.innerHeight * 0.3, 0), Math.max(total, 1));
      bar.style.transform = `scaleX(${total > 0 ? done / total : 1})`;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-kieu-sticky-booking-bar"] && !Shopify.designMode) return;
  try {
    
  class DrKieuStickyBookingBar extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.firstSection = null;
      this.footer = null;
      this.scrollTarget = null;
      this.handleScroll = this.scheduleUpdate.bind(this);
      this.handleViewportChange = this.bindScrollTarget.bind(this);
    }

    connectedCallback() {
      this.setup();
    }

    disconnectedCallback() {
      this.teardown();
    }

    setup() {
      this.teardown();

      if (!this.classList.contains('dk-sticky-booking-bar--fixed')) {
        this.classList.remove('dk-sticky-booking-bar--viewport-hidden');
        return;
      }

      this.firstSection = [...document.querySelectorAll('#MainContent .shopify-section')].find(
        (candidate) => !candidate.contains(this) && candidate.getClientRects().length > 0
      );
      this.footer = document.querySelector('.dk-footer');
      this.controller = new AbortController();
      this.viewportQuery = window.matchMedia('(min-width: 990px)');
      this.viewportQuery.addEventListener('change', this.handleViewportChange, { signal: this.controller.signal });
      window.addEventListener('resize', this.handleScroll, { passive: true, signal: this.controller.signal });
      window.addEventListener('load', this.handleScroll, { signal: this.controller.signal });
      this.bindScrollTarget();
    }

    teardown() {
      if (this.frame !== null) {
        window.cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      if (this.scrollTarget) {
        this.scrollTarget.removeEventListener('scroll', this.handleScroll);
        this.scrollTarget = null;
      }

      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
    }

    bindScrollTarget() {
      if (this.scrollTarget) {
        this.scrollTarget.removeEventListener('scroll', this.handleScroll);
      }

      this.scrollContainer = this.viewportQuery.matches
        ? document.querySelector('.page-wrapper') || document.scrollingElement
        : document.scrollingElement;
      this.scrollTarget = this.viewportQuery.matches && this.scrollContainer?.matches('.page-wrapper')
        ? this.scrollContainer
        : document;
      this.scrollTarget.addEventListener('scroll', this.handleScroll, { passive: true });
      this.scheduleUpdate();
    }

    scheduleUpdate() {
      if (this.frame !== null) return;

      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.updatePosition();
      });
    }

    updatePosition() {
      const viewportHeight = this.scrollTarget === document ? window.innerHeight : this.scrollContainer.clientHeight;
      const isInFirstSection = this.firstSection ? this.firstSection.getBoundingClientRect().bottom > 0 : false;
      const footerIsVisible = this.footer ? this.footer.getBoundingClientRect().top < viewportHeight : false;

      this.classList.toggle('dk-sticky-booking-bar--viewport-hidden', isInFirstSection || footerIsVisible);
    }
  }

  if (!customElements.get('dr-kieu-sticky-booking-bar')) {
    customElements.define('dr-kieu-sticky-booking-bar', DrKieuStickyBookingBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kieu-erstattungs-check"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dr-kieu-reimbursement-check')) {
    class DrKieuReimbursementCheck extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.settings = JSON.parse(this.querySelector('[data-reimbursement-settings]').textContent);
        this.insurance = null;
        this.program = null;
        this.submitting = false;
        this.programStep = this.querySelector('[data-reimbursement-program]');
        this.contactStep = this.querySelector('[data-reimbursement-contact]');
        this.leadForm = this.querySelector('[data-reimbursement-lead]');
        this.formStatus = this.querySelector('[data-reimbursement-form-status]');
        this.submitButton = this.querySelector('[data-reimbursement-submit]');
        this.result = this.querySelector('[data-reimbursement-result]');
        this.insuranceButtons = Array.from(this.querySelectorAll('[data-insurance]'));
        this.programButtons = Array.from(this.querySelectorAll('[data-program]'));
        this.addEventListener('click', (event) => this.handleClick(event));
        this.leadForm.addEventListener('submit', (event) => this.submitLead(event));
      }

      handleClick(event) {
        const insuranceButton = event.target.closest('[data-insurance]');
        if (insuranceButton && this.contains(insuranceButton)) {
          this.insurance = insuranceButton.dataset.insurance;
          this.program = null;
          this.updatePressed(this.insuranceButtons, insuranceButton);
          this.updatePressed(this.programButtons, null);
          this.programStep.hidden = false;
          this.contactStep.hidden = true;
          this.clearResult();
          this.setFormStatus('');
          this.scrollToElement(this.programStep);
          return;
        }

        const programButton = event.target.closest('[data-program]');
        if (programButton && this.contains(programButton)) {
          this.program = programButton.dataset.program;
          this.updatePressed(this.programButtons, programButton);
          this.contactStep.hidden = false;
          this.clearResult();
          this.setFormStatus('');
          this.scrollToElement(this.contactStep);
          return;
        }

        const resetButton = event.target.closest('[data-reimbursement-reset]');
        if (resetButton && this.contains(resetButton)) this.reset();
      }

      updatePressed(buttons, activeButton) {
        buttons.forEach((button) => button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false'));
      }

      async submitLead(event) {
        event.preventDefault();
        if (this.submitting || !this.result.hidden || !this.insurance || !this.program || !this.leadForm.reportValidity()) return;

        if (this.dataset.croReview === 'true') {
          this.contactStep.hidden = true;
          this.renderResult(true);
          return;
        }
        const portalId = String(this.settings.hubspotPortalId || '').trim();
        const formGuid = String(this.settings.hubspotFormGuid || '').trim();
        if (!/^\d+$/.test(portalId) || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(formGuid)) {
          this.setFormStatus('Die Auswertung ist gerade nicht verbunden. Bitte nutze das kostenlose Gespräch.', 'error');
          return;
        }

        const formData = new FormData(this.leadForm);
        if (String(formData.get('website') || '').trim()) {
          this.contactStep.hidden = true;
          this.renderResult(true);
          return;
        }
        const firstName = String(formData.get('firstname') || '').trim();
        const email = String(formData.get('email') || '').trim();
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 12000);

        this.setSubmitting(true);
        this.setFormStatus('');
        this.prepareLeadMeasurement();

        try {
          const response = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              fields: [
                { objectTypeId: '0-1', name: 'firstname', value: firstName },
                { objectTypeId: '0-1', name: 'email', value: email }
              ],
              submittedAt: String(Date.now()),
              context: {
                pageUri: `${window.location.origin}${window.location.pathname}`,
                pageName: document.title
              }
            }),
            signal: controller.signal
          });

          if (!response.ok) throw new Error(`HubSpot form submission failed with ${response.status}`);
          if (response.status === 200) {
            Promise.resolve().then(() => response.json()).then((result) => {
              if (result && !result.errors && (typeof result.inlineMessage === 'string' || typeof result.redirectUri === 'string')) this.sendLeadEvent();
            }).catch(() => {});
          }
          this.contactStep.hidden = true;
          this.renderResult(true);
        } catch (error) {
          this.setFormStatus('Das hat gerade nicht funktioniert. Bitte versuche es noch einmal oder nutze das kostenlose Gespräch.', 'error');
        } finally {
          window.clearTimeout(timeoutId);
          this.setSubmitting(false);
        }
      }

      setSubmitting(isSubmitting) {
        this.submitting = isSubmitting;
        this.submitButton.disabled = isSubmitting;
        this.submitButton.textContent = isSubmitting ? 'Einordnung wird geladen …' : 'Einordnung anzeigen';
      }

      prepareLeadMeasurement() {
        if (!this.dataset.ga4MeasurementId) return;
        try { window.KieuBookingGA4?.prepareLead({ measurementId: this.dataset.ga4MeasurementId }); } catch (_) {}
      }

      sendLeadEvent() {
        if (!this.dataset.ga4MeasurementId) return;
        try { window.KieuBookingGA4?.sendLead({ measurementId: this.dataset.ga4MeasurementId }); } catch (_) {}
      }

      setFormStatus(message, state = '') {
        this.formStatus.textContent = message;
        this.formStatus.hidden = !message;
        if (state) this.formStatus.dataset.state = state;
        else delete this.formStatus.dataset.state;
      }

      clearResult() {
        this.result.hidden = true;
        this.result.replaceChildren();
      }

      async scrollToElement(element) {
        const { getScrollContainer } = await import('@theme/scroll-container');
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        window.requestAnimationFrame(() => {
          const container = getScrollContainer();
          const rect = element.getBoundingClientRect();
          const header = document.getElementById('header-component');
          const top = (header?.getBoundingClientRect().height || 0) + 24;
          const bottom = window.innerHeight - 24;
          let delta = 0;

          if (rect.top < top || rect.height > bottom - top) {
            delta = rect.top - top;
          } else if (rect.bottom > bottom) {
            delta = rect.bottom - bottom;
          }

          if (Math.abs(delta) > 1) {
            container.scrollTo({ top: container.scrollTop + delta, behavior });
          }
        });
      }

      escapeAttribute(value) {
        return String(value).replace(/[&<>"']/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        })[character]);
      }

      renderResult(shouldScroll) {
        if (!this.insurance || !this.program) return;

        const programs = {
          regular: {
            label: 'reguläre kieu360-Checkup',
            title: 'Regulärer kieu360-Checkup: zwei Termine.',
            body: 'Der reguläre Checkup findet an zwei Untersuchungsterminen statt. Die tatsächlich erbrachten ärztlichen Leistungen werden je Sitzung nach GOÄ abgebildet. Für die Erstattung prüft deine Versicherung anschließend jede Rechnungsposition nach deinem Vertrag.',
            bookingUrl: this.settings.bookingUrl,
            bookingLabel: 'Regulären Check-up buchen'
          },
          executive: {
            label: 'kieu360-Checkup Executive',
            title: 'Executive: alle Untersuchungen an einem Tag.',
            body: 'Beim Executive bündeln wir alle Untersuchungen an einem Tag. Die GOÄ begrenzt bestimmte Ultraschallpositionen je Sitzung. Deshalb können einzelne Sono-Leistungen nicht im selben Umfang berechnet — und damit auch nicht zur Erstattung eingereicht — werden wie beim regulären Checkup. Der mögliche Erstattungsanteil kann dadurch geringer ausfallen.',
            bookingUrl: this.settings.executiveBookingUrl,
            bookingLabel: 'Executive buchen'
          }
        };

        const selectedProgram = programs[this.program];

        const base = {
          pkv: {
            title: 'Privat versichert: Bis zu 100 % Erstattung möglich.',
            body: 'Ohne Beihilfe reichst du unsere Rechnungen bei deiner privaten Krankenversicherung ein. Mit Beihilfe gehen dieselben Unterlagen an die Beihilfestelle und die private Restkostenversicherung. Eine vollständige Erstattung ist möglich. Maßgeblich sind dein Tarif, die medizinische Indikation, ein möglicher Selbstbehalt und gegebenenfalls die Beihilfevorschriften. Nicht jede Leistung wird vollständig erstattet. Medizinisch begründete und reine Vorsorgeanteile weisen wir auf der Rechnung nachvollziehbar aus.'
          },
          zusatz: {
            title: 'Deine Rechnungen gehen an den Zusatztarif, nicht an die gesetzliche Kasse.',
            body: 'Suche in deinen Versicherungsunterlagen nach „ambulante ärztliche Behandlung“. Viele Zusatztarife erstatten privatärztliche Leistungen ganz oder anteilig bis zu einem Jahreshöchstbetrag. Die medizinische Begründung steht auf unserer Rechnung.'
          },
          bkv: {
            title: 'Das Gesundheitsbudget deines Arbeitgebers kann sich beteiligen.',
            body: 'Du reichst die Rechnungen beim Anbieter des Budgets ein, nicht bei deiner Krankenkasse. Deine Personalabteilung kann dir sagen, welche Leistungen umfasst sind und wie viel Budget im laufenden Jahr noch verfügbar ist.'
          },
          gkv: {
            title: 'Als Selbstzahler bist du bei uns willkommen.',
            body: `Die gesetzliche Krankenkasse erstattet privatärztliche Leistungen dieser Art nicht. Leistungen und Honorar für den ${selectedProgram.label} besprechen wir persönlich vor deiner Entscheidung. Zusatzuntersuchungen besprechen wir immer vorab mit dir.`
          }
        };

        const selected = base[this.insurance];
        const insuranceRequest = this.insurance === 'gkv' ? '' : `
          <div class="dk-reimbursement__result-panel">
            <h3 class="dk-reimbursement__result-panel-title dk-type-headline-03">Soll ich vorher bei meiner Versicherung anfragen?</h3>
            <p class="dk-type-body-03">Wenn du vorab Klarheit möchtest, frage deine Versicherung nach den Bedingungen deines Tarifs. Wir unterstützen dich mit Informationen zu den geplanten Leistungen. Eine verbindliche Erstattungszusage kann nur deine Versicherung geben.</p>
          </div>`;
        const estimateRequest = `
          <div class="dk-reimbursement__result-panel">
            <h3 class="dk-reimbursement__result-panel-title dk-type-headline-03">Brauche ich vorher einen Kostenvoranschlag?</h3>
            <p class="dk-type-body-03">Wir besprechen Leistungen und Honorar persönlich, bevor du dich entscheidest. Zusatzuntersuchungen besprechen wir immer vorab mit dir. Eine Aufstellung der geplanten Leistungen bekommst du, wenn du sie brauchst — für die Buchung nötig ist sie nicht.</p>
          </div>`;
        const employerNote = this.insurance === 'bkv' ? `
          <div class="dk-reimbursement__result-panel">
            <h3 class="dk-reimbursement__result-panel-title dk-type-headline-03">Kein Gesundheitsbudget bekannt?</h3>
            <p class="dk-type-body-03">Frage deine Personalabteilung nach einer betrieblichen Krankenversicherung oder einem Gesundheitsbudget und nach dem aktuell verfügbaren Betrag.</p>
          </div>` : '';

        this.result.innerHTML = `
          <div class="dk-reimbursement__result-copy">
            <h3 class="dk-reimbursement__result-title dk-type-headline-02">${selected.title}</h3>
            <p class="dk-type-body-02">${selected.body}</p>
          </div>
          <div class="dk-reimbursement__result-panels">
            <div class="dk-reimbursement__result-panel">
              <h3 class="dk-reimbursement__result-panel-title dk-type-headline-03">${selectedProgram.title}</h3>
              <p class="dk-type-body-03">${selectedProgram.body}</p>
            </div>
            <div class="dk-reimbursement__result-panel">
              <h3 class="dk-reimbursement__result-panel-title dk-type-headline-03">Was du von uns bekommst</h3>
              <p class="dk-type-body-03">Zwei Rechnungen nach der Gebührenordnung für Ärzte: eine vom Labor und eine von uns. Sie dokumentieren die vorab besprochenen Leistungen und sind nachvollziehbar für die Prüfung durch deine Versicherung aufgebaut.</p>
            </div>
            ${insuranceRequest}
            ${estimateRequest}
            ${employerNote}
          </div>
          <div class="dk-reimbursement__result-cta">
            <div>
              <h3 class="dk-reimbursement__result-title dk-type-headline-02">Deinen nächsten Schritt persönlich klären</h3>
              <p class="dk-type-body-02">Wir besprechen Ablauf, Leistungen und deine Fragen zur Erstattung vor deiner Entscheidung. Vereinbare dafür ein unverbindliches Gespräch mit unserem Team.</p>
            </div>
            <div class="dk-reimbursement__result-actions">
              <a class="button-dr-kieu-primary" href="${this.escapeAttribute(selectedProgram.bookingUrl)}" data-kieu-booking-trigger data-kieu-booking-entry="reimbursement_result">${selectedProgram.bookingLabel}</a>
              <a class="button-dr-kieu-secondary" href="${this.escapeAttribute(this.settings.consultationUrl)}">15 Minuten kostenlos sprechen</a>
            </div>
          </div>
          <div class="dk-reimbursement__result-footer">
            <p class="dk-reimbursement__disclaimer dk-type-body-03">Die Erstattungsentscheidung trifft ausschließlich deine Versicherung auf Grundlage deines Vertrags. Wir können keine Kostenübernahme zusagen. Wir sagen dir aber vorab, welche Kosten entstehen, und erstellen nachvollziehbare GOÄ-Rechnungen.</p>
            <button class="dk-reimbursement__reset dk-type-body-03" type="button" data-reimbursement-reset>Antworten ändern</button>
          </div>`;
        this.result.hidden = false;

        if (shouldScroll) {
          this.scrollToElement(this.result);
        }
      }

      reset() {
        this.insurance = null;
        this.program = null;
        this.updatePressed(this.insuranceButtons, null);
        this.updatePressed(this.programButtons, null);
        this.programStep.hidden = true;
        this.contactStep.hidden = true;
        this.leadForm.reset();
        this.setFormStatus('');
        this.clearResult();
        this.insuranceButtons[0]?.focus({ preventScroll: true });
        this.scrollToElement(this);
      }
    }

    customElements.define('dr-kieu-reimbursement-check', DrKieuReimbursementCheck);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
